import api from "../../services/api";
import { useEffect, useMemo, useState } from "react";
import useAuth from "../useAuth";

const useMe = () => {
  const { token, tokenType, signOut } = useAuth();
  const config = useMemo(
    () => ({
      headers: { Authorization: `Bearer ${token}` },
    }),
    [token],
  );

  const [me, setme] = useState();
  const [reload, setreload] = useState();
  useEffect(() => {
    if (token) {
      try {
        if (tokenType === "login_gestor") {
          api
            .get("/user/profile", config)
            .then(data => {
              setme({
                ...data.data,
                name: data.data.username,
                type: "Gestor",
              });
            })
            .catch(__err => {
              signOut();
              console.log("__err", __err);
            });
        } else {
          api
            .get("/trainee/profile?joins=commercials.institution,commercials.course,currentPaymentSlips", config)
            .then(data => {
              setme({
                ...data.data,
                username: data.data.name,
                type: "Formando",
              });
              if (!data?.data?.active) {
                signOut();
              }
            })
            .catch(__err => {
              signOut();
              console.log("__err", __err);
            });
        }
      } catch (__error) {
        console.error("__error", __error);
      }
    }
  }, [reload, token, tokenType, signOut, config]);

  const loadMe = () => {
    !me && setreload(!reload);
  };
  const reloadMe = () => {
    setreload(!reload);
  };

  return {
    me,
    loadMe,
    reloadMe,
  };
};

export default useMe;
